var map = {
	"./bigTruck/bigTruck-red.png": "e890",
	"./bus/bus-red.png": "f448",
	"./car/car-red.png": "2760",
	"./container/container-red.png": "7932",
	"./doubleCabin/doubleCabin-red.png": "f531",
	"./electricCar/electricCar-red.png": "7617",
	"./electricMotorcycle/electricMotorcycle-red.png": "10a5",
	"./excavator/excavator-red.png": "3ef8",
	"./motorcycle/motorcycle-red.png": "18e2",
	"./smallTruck/smallTruck-red.png": "af62",
	"./tractor/tractor-red.png": "6284",
	"./truckHead/truckHead-red.png": "5c83",
	"./van/van-red.png": "0b39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3990";